import React from 'react';

export const FontStyleItalic = () => (
    <>
        <line x1='11' y1='5' x2='17' y2='5' />
        <line x1='7' y1='19' x2='13' y2='19' />
        <line x1='14' y1='5' x2='10' y2='19' />
    </>
);